// Schéma déclaratif du "Relevé d'étude sur place" — 3 variantes reproduites fidèlement
// d'après les formulaires externes valnexo.fr (CEE fiches / Réno appartement / Réno immeuble).
// Types de champ : text | number | textarea | date | select | cards | checks | toggle |
//                  photo | file | info | link | repeater

export const USAGE_OPTIONS = [
    'Bureaux', 'Commerce', 'Hôtel', 'Restaurant / Bar', 'Salle de sport', 'Gymnase',
    'Salle de spectacle / Cinéma', 'Hôpital / Clinique / EHPAD', 'École / Centre de formation',
    'Mairie / Bâtiment public', 'Entrepôt / Halle logistique', 'Atelier / Carrosserie',
    'Industrie légère / Production', 'Serre / Maraîchage / Horticulture', 'Aquaculture',
    'Camping / Village vacances', 'Bâtiment mixte', 'Autre',
];

// Étape commune : choix de la variante de relevé
export const TYPE_STEP = {
    id: 'type_dossier', title: 'Type de dossier',
    sections: [{
        fields: [
            { type: 'info', text: 'Choisissez le type de relevé. Le formulaire s\'adapte automatiquement à votre choix.' },
            {
                type: 'cards', key: 'form_variant', label: 'Type de dossier', multi: false,
                options: [
                    { value: 'cee_fiches', label: 'Étude CEE par fiches standardisées', desc: 'Tertiaire, agricole, collectivité, industrie, multi-sites' },
                    { value: 'reno_appartement', label: 'Rénovation globale — Logement / Appartement', desc: 'Isolation / Chauffage / Climatisation (logement seul)' },
                    { value: 'reno_immeuble', label: 'Rénovation globale — Immeuble collectif', desc: "Rénovation globale d'ampleur en copropriété" },
                ],
            },
        ],
    }],
};

// ====================== VARIANTE 1 : CEE par fiches standardisées ======================
const CEE_STEPS = [
    {
        id: 'porteur', title: 'Nature du porteur',
        sections: [{
            fields: [{
                type: 'cards', key: 'nature_porteur', label: 'Nature du porteur', multi: false,
                options: [
                    { value: 'Entreprise privée', label: 'Entreprise privée' },
                    { value: 'Collectivité', label: 'Collectivité' },
                    { value: 'Établissement public', label: 'Établissement public' },
                    { value: 'Association / Fondation', label: 'Association / Fondation' },
                    { value: 'Exploitation agricole', label: 'Exploitation agricole' },
                    { value: 'Autre', label: 'Autre' },
                ],
            }],
        }],
    },
    {
        id: 'structure', title: 'Structure',
        sections: [{
            title: 'Identification de la structure',
            fields: [
                { type: 'text', key: 'raison_sociale', label: 'Raison sociale', placeholder: 'Raison sociale *', required: true },
                { type: 'text', key: 'siren', label: 'SIREN', placeholder: 'SIREN' },
                { type: 'text', key: 'siret', label: 'SIRET', placeholder: 'SIRET' },
                { type: 'text', key: 'code_ape', label: 'Code APE/NAF', placeholder: 'Code APE/NAF' },
                { type: 'text', key: 'forme_juridique', label: 'Forme juridique', placeholder: 'Forme juridique' },
                { type: 'text', key: 'adresse_siege', label: 'Adresse du siège', placeholder: 'Adresse du siège', full: true },
            ],
        }],
    },
    {
        id: 'site', title: 'Coordonnées du site',
        sections: [{
            fields: [
                { type: 'text', key: 'site_nom', label: 'Nom du site', placeholder: 'Nom du site *', required: true, full: true },
                { type: 'text', key: 'site_adresse', label: 'Adresse exacte', placeholder: 'Adresse exacte *', required: true, full: true },
                { type: 'text', key: 'site_cp', label: 'Code postal', placeholder: 'Code postal *', required: true },
                { type: 'text', key: 'site_ville', label: 'Ville', placeholder: 'Ville *', required: true },
                { type: 'date', key: 'date_visite', label: 'Date de visite' },
                { type: 'text', key: 'technicien_nom', label: 'Nom du technicien sur place', placeholder: 'Prénom Nom' },
            ],
        }],
    },
    {
        id: 'contacts', title: 'Contacts',
        sections: [
            {
                title: 'Contact principal',
                fields: [
                    { type: 'text', key: 'contact_prenom', label: 'Prénom', placeholder: 'Prénom' },
                    { type: 'text', key: 'contact_nom', label: 'Nom', placeholder: 'Nom' },
                    { type: 'text', key: 'contact_fonction', label: 'Fonction', placeholder: 'Fonction' },
                    { type: 'text', key: 'contact_tel', label: 'Téléphone', placeholder: 'Téléphone' },
                    { type: 'text', key: 'contact_email', label: 'Email', placeholder: 'Email' },
                    {
                        type: 'cards', key: 'contact_decideur', label: 'Cette personne est-elle le décideur ?', multi: false,
                        options: [{ value: 'Oui', label: 'Oui' }, { value: 'Non', label: 'Non' }, { value: 'Co-décision', label: 'Co-décision' }],
                    },
                    { type: 'toggle', key: 'contact_tech_distinct', label: 'Contact technique distinct', hint: 'Cochez si un contact technique différent doit être renseigné' },
                ],
            },
            {
                title: 'Contact technique', showIf: (d) => d.contact_tech_distinct === true,
                fields: [
                    { type: 'text', key: 'contact_tech_prenom', label: 'Prénom', placeholder: 'Prénom' },
                    { type: 'text', key: 'contact_tech_nom', label: 'Nom', placeholder: 'Nom' },
                    { type: 'text', key: 'contact_tech_fonction', label: 'Fonction', placeholder: 'Fonction' },
                    { type: 'text', key: 'contact_tech_tel', label: 'Téléphone', placeholder: 'Téléphone' },
                    { type: 'text', key: 'contact_tech_email', label: 'Email', placeholder: 'Email' },
                ],
            },
        ],
    },
    {
        id: 'geoportail', title: 'Cartographie',
        sections: [{
            title: 'Cartographie Géoportail',
            fields: [
                { type: 'info', variant: 'warning', text: "⚠️ Capture Géoportail OBLIGATOIRE. La capture doit montrer clairement le bâtiment/site, l'adresse affichée et les coordonnées GPS." },
                { type: 'link', label: 'Naviguer sur Géoportail', url: 'https://www.geoportail.gouv.fr/carte' },
                { type: 'photo', category: 'geoportail_general', label: 'Capture vue générale', desc: "Vue d'ensemble du site", max: 2 },
                { type: 'photo', category: 'geoportail_zoom', label: 'Capture zoom bâtiment', desc: 'Vue rapprochée du/des bâtiment(s)', max: 2 },
                { type: 'select', key: 'usage_site', label: 'Usage réel principal du site', options: USAGE_OPTIONS },
                {
                    type: 'cards', key: 'config_site', label: 'Configuration du site', multi: false,
                    options: [
                        { value: 'Un seul bâtiment', label: 'Un seul bâtiment' },
                        { value: 'Plusieurs bâtiments sur un même site', label: 'Plusieurs bâtiments sur un même site' },
                        { value: 'Plusieurs sites', label: 'Plusieurs sites' },
                    ],
                },
            ],
        }],
    },
    {
        id: 'technique', title: 'Données techniques',
        sections: [{
            title: 'Données techniques générales',
            fields: [
                { type: 'number', key: 'surface_chauffee', label: 'Surface chauffée (m²)', placeholder: 'Ex: 500', required: true },
                { type: 'number', key: 'hauteur_plafond', label: 'Hauteur sous plafond (m)', placeholder: 'Ex: 3.5' },
                { type: 'number', key: 'nb_niveaux', label: 'Nombre de niveaux', placeholder: 'Ex: 2' },
                { type: 'text', key: 'annee_construction', label: 'Année construction', placeholder: 'Ex: 1985' },
                { type: 'text', key: 'horaires_occupation', label: "Horaires d'occupation", placeholder: 'Ex: 8h-18h du lundi au vendredi', full: true },
                { type: 'text', key: 'saisonnalite', label: 'Saisonnalité', placeholder: "Ex: Activité toute l'année / Saisonnier été", full: true },
                { type: 'textarea', key: 'description_activite', label: "Description de l'activité du site", placeholder: "Décrivez l'activité principale...", full: true },
            ],
        }],
    },
    {
        id: 'energies', title: 'Énergies',
        sections: [{
            title: 'Énergies présentes',
            fields: [
                {
                    type: 'checks', key: 'energies_dispo', label: 'Énergies disponibles sur le site',
                    options: [
                        { value: 'Électricité', label: 'Électricité' }, { value: 'Gaz naturel', label: 'Gaz naturel' },
                        { value: 'Fioul', label: 'Fioul' }, { value: 'Propane / GPL', label: 'Propane / GPL' },
                        { value: 'Bois / Biomasse', label: 'Bois / Biomasse' }, { value: 'Autre', label: 'Autre' },
                    ],
                },
                { type: 'text', key: 'puissance_souscrite', label: 'Puissance souscrite', placeholder: 'Ex: 36 kVA' },
                { type: 'select', key: 'type_alimentation', label: 'Type alimentation', options: ['Monophasé', 'Triphasé'] },
                { type: 'text', key: 'marge_electrique', label: 'Marge électrique disponible', placeholder: 'Ex: 10 kVA' },
                { type: 'text', key: 'pdl_pce', label: 'PDL / PCE', placeholder: 'PDL / PCE (si disponible)' },
                { type: 'select', key: 'augmentation_possible', label: 'Augmentation possible ?', options: ['Oui', 'Non', 'À vérifier'] },
                { type: 'select', key: 'factures_dispo', label: 'Factures énergie disponibles ?', options: ['Oui', 'Non', 'Partiellement'] },
                { type: 'select', key: 'contrat_maintenance', label: 'Contrat maintenance ?', options: ['Oui', 'Non'] },
                { type: 'select', key: 'historique_conso', label: 'Historique conso', options: ['Moins de 12 mois', '12 mois', '24 mois', '36 mois ou plus'] },
                { type: 'file', category: 'documents_energie', label: 'Documents énergie (factures, contrats...)' },
            ],
        }],
    },
    {
        id: 'lots', title: 'Lots techniques',
        sections: [
            {
                title: 'Lots techniques à analyser',
                fields: [{
                    type: 'checks', key: 'lots_techniques', label: 'Sélectionnez les lots à analyser', cards: true,
                    options: [
                        { value: 'Chauffage / PAC', label: 'Chauffage / PAC', desc: 'Chaudières, pompes à chaleur, radiateurs' },
                        { value: 'Climatisation', label: 'Climatisation', desc: 'Splits, VRV, groupes froids clim' },
                        { value: 'Eau chaude sanitaire', label: 'Eau chaude sanitaire', desc: 'Ballons, échangeurs, production ECS' },
                        { value: 'Ventilation / CTA', label: 'Ventilation / CTA', desc: 'VMC, CTA, extracteurs' },
                        { value: 'Éclairage', label: 'Éclairage', desc: 'Luminaires, commande, détecteurs' },
                        { value: 'Froid / Groupes froids / HP-BP', label: 'Froid / Groupes froids / HP-BP', desc: 'Chambres froides, compresseurs' },
                        { value: 'Pompes / Variateurs', label: 'Pompes / Variateurs', desc: 'Circulateurs, ventilateurs, variateurs' },
                        { value: 'Déshumidification', label: 'Déshumidification', desc: 'Déshumidificateurs industriels' },
                        { value: 'Air comprimé', label: 'Air comprimé', desc: 'Compresseurs, réseau air' },
                        { value: 'Serre / Gestion climatique', label: 'Serre / Gestion climatique', desc: 'Serres, maraîchage, écrans thermiques' },
                        { value: 'Ventilation / VMC Agricole', label: 'Ventilation / VMC Agricole', desc: 'Serres, élevage, stockage' },
                        { value: 'Piscine / Camping', label: 'Piscine / Camping', desc: 'Bassins, blocs sanitaires, allées' },
                        { value: 'Autre', label: 'Autre', desc: 'Autre équipement spécifique' },
                    ],
                }],
            },
            {
                title: 'Groupes froids — Relevé par secteur',
                showIf: (d) => Array.isArray(d.lots_techniques) && d.lots_techniques.includes('Froid / Groupes froids / HP-BP'),
                fields: [
                    { type: 'info', text: "Ajoutez chaque secteur (zone du site) puis tous les groupes froids qui s'y trouvent. Pour chaque groupe : caractéristiques, relevés (HP/BP, températures…) et photos. Les photos peuvent être prises à la caméra OU choisies dans la galerie (ex : capture Géoportail)." },
                    { type: 'cold_groups', key: 'secteurs_froid', label: 'Secteurs & groupes froids' },
                    { type: 'file', category: 'factures_groupes_froids', label: "Factures d'achat des groupes froids", desc: "Preuve d'acquisition : marque, modèle, puissance, date d'achat" },
                ],
            },
        ],
    },
    {
        id: 'photos', title: 'Photos',
        sections: [{
            title: 'Photos obligatoires',
            fields: [
                { type: 'photo', category: 'photo_facade', label: 'Façade / Vue générale *', desc: "Vue d'ensemble du bâtiment", max: 4, required: true },
                { type: 'photo', category: 'photo_vue_site', label: 'Vue générale site', desc: "Vue d'ensemble du site", max: 4 },
                { type: 'photo', category: 'photo_local_technique', label: 'Local technique', desc: 'Chaufferie, local électrique...', max: 6 },
                { type: 'photo', category: 'photo_tableau', label: 'Tableau / Armoire', desc: 'Tableau électrique principal', max: 6 },
                { type: 'photo', category: 'photo_locaux', label: 'Photos des locaux concernés', desc: 'Espaces à rénover', max: 6 },
                { type: 'photo', category: 'photo_equipements', label: 'Photos des équipements principaux', desc: 'Chaudières, CTA, compresseurs...', max: 8 },
                { type: 'photo', category: 'photo_plaques', label: 'Photos des plaques signalétiques', desc: 'Lisibles : marque, modèle, puissance', max: 10 },
            ],
        }],
    },
    {
        id: 'documents', title: 'Documents',
        sections: [{
            title: 'Documents à joindre',
            fields: [
                { type: 'info', text: 'Documents recommandés : KBIS, factures énergie, plans, contrats maintenance, devis existants.' },
                { type: 'file', category: 'doc_kbis', label: 'KBIS ou équivalent' },
                { type: 'file', category: 'doc_factures', label: 'Factures énergie' },
                { type: 'file', category: 'doc_plan', label: "Plan ou schéma d'implantation" },
                { type: 'file', category: 'doc_contrat_maintenance', label: 'Contrat maintenance' },
                { type: 'file', category: 'doc_devis', label: 'Devis existants' },
            ],
        }],
    },
    {
        id: 'synthese', title: 'Synthèse & validation',
        sections: [{
            fields: [
                {
                    type: 'cards', key: 'niveau_completude', label: 'Niveau de complétude', multi: false,
                    options: [
                        { value: "Complet pour bureau d'étude", label: "Complet pour bureau d'étude" },
                        { value: 'Exploitable avec réserves', label: 'Exploitable avec réserves' },
                        { value: 'Incomplet', label: 'Incomplet' },
                    ],
                },
                { type: 'text', key: 'nom_charge_etude', label: "Nom du chargé d'étude", placeholder: 'Votre nom', full: true },
                { type: 'textarea', key: 'commentaires', label: 'Commentaires, observations', placeholder: "Points d'attention...", full: true },
                { type: 'toggle', key: 'confirmation', label: 'Je confirme que les informations et pièces jointes correspondent bien au site concerné.', hint: 'Obligatoire pour valider.' },
            ],
        }],
    },
];

// ====================== VARIANTE 2 : Rénovation globale — Logement / Appartement ======================
const APPARTEMENT_STEPS = [
    {
        id: 'bien', title: 'Type de bien & client',
        sections: [
            {
                title: 'Type de bien',
                fields: [{
                    type: 'cards', key: 'type_bien', label: 'Type de bien', multi: false,
                    options: [
                        { value: 'Appartement', label: 'Appartement', desc: 'En immeuble collectif' },
                        { value: 'Villa / Maison', label: 'Villa / Maison', desc: 'Maison individuelle' },
                    ],
                }],
            },
            {
                title: 'Informations client',
                fields: [
                    { type: 'text', key: 'nom_client', label: 'Nom du client', placeholder: 'Nom du client *', required: true },
                    { type: 'text', key: 'prenom_client', label: 'Prénom', placeholder: 'Prénom *', required: true },
                    { type: 'text', key: 'adresse', label: 'Adresse (N° et rue)', placeholder: 'Adresse (N° et rue) *', required: true, full: true },
                    { type: 'text', key: 'code_postal', label: 'Code postal', placeholder: 'Code postal *', required: true },
                    { type: 'text', key: 'ville', label: 'Ville', placeholder: 'Ville *', required: true },
                ],
            },
        ],
    },
    {
        id: 'logement', title: 'Caractéristiques du logement',
        sections: [{
            fields: [
                { type: 'cards', key: 'type_logement', label: 'Type de logement', multi: false, options: ['T1', 'T2', 'T3', 'T4', 'T5+'].map((v) => ({ value: v, label: v })) },
                { type: 'number', key: 'surface_habitable', label: 'Surface habitable (m²)', placeholder: 'Surface habitable (m²) *', required: true },
                { type: 'number', key: 'nb_chambres', label: 'Nombre de chambres', placeholder: 'Nombre de chambres' },
            ],
        }],
    },
    {
        id: 'statut', title: 'Statut et revenus',
        sections: [{
            fields: [
                {
                    type: 'cards', key: 'statut_occupant', label: 'Vous êtes', multi: false,
                    options: [
                        { value: 'Propriétaire occupant', label: 'Propriétaire occupant' },
                        { value: 'Propriétaire bailleur', label: 'Propriétaire bailleur' },
                        { value: 'Locataire', label: 'Locataire' },
                    ],
                },
                { type: 'info', text: 'Revenus CEE — ces informations permettent de déterminer le niveau d\'aide.' },
                { type: 'number', key: 'revenu_fiscal', label: 'Revenu fiscal de référence (€)', placeholder: 'Revenu fiscal de référence (€)' },
                { type: 'number', key: 'parts_fiscales', label: 'Nombre de parts fiscales', placeholder: 'Nombre de parts fiscales' },
            ],
        }],
    },
    {
        id: 'chauffage', title: 'Mode de chauffage',
        sections: [{
            fields: [{
                type: 'cards', key: 'mode_chauffage', label: 'Mode de chauffage', multi: false,
                options: ['Chauffage collectif gaz', 'Chauffage collectif (autre)', 'Chauffage électrique individuel', 'Chauffage gaz individuel', 'Pompe à chaleur', 'Autre'].map((v) => ({ value: v, label: v })),
            }],
        }],
    },
    {
        id: 'ecs', title: "Production d'eau chaude",
        sections: [{
            fields: [{
                type: 'cards', key: 'type_ecs', label: 'Type de production ECS', multi: false,
                options: ['Ballon électrique', 'Ballon thermodynamique', 'Production collective', 'Chaudière', 'Autre'].map((v) => ({ value: v, label: v })),
            }],
        }],
    },
    {
        id: 'ballon', title: "Ballon d'eau chaude sanitaire",
        sections: [{
            title: "Ballon d'eau chaude sanitaire",
            showIf: (d) => ['Ballon électrique', 'Ballon thermodynamique'].includes(d.type_ecs),
            fields: [
                { type: 'info', text: "Cette section s'applique aux ballons électriques ou thermodynamiques." },
                { type: 'text', key: 'ballon_marque', label: 'Marque', placeholder: 'Marque' },
                { type: 'number', key: 'ballon_capacite', label: 'Capacité (litres)', placeholder: 'Capacité (litres)' },
                { type: 'text', key: 'ballon_annee', label: 'Année', placeholder: "Année d'installation" },
                { type: 'photo', category: 'photo_ballon', label: 'Photo du ballon / plaque signalétique', max: 3 },
            ],
        }],
    },
    {
        id: 'plafond', title: 'Nature du plafond',
        sections: [{
            fields: [
                {
                    type: 'cards', key: 'type_plafond', label: 'Type de plafond', multi: false,
                    options: ['Toit terrasse (dernier étage)', 'Sous combles perdus', 'Plancher haut (étage supérieur)', 'Autre configuration'].map((v) => ({ value: v, label: v })),
                },
                { type: 'toggle', key: 'isolation_plafond', label: 'Isolation existante au plafond' },
            ],
        }],
    },
    {
        id: 'murs', title: 'Murs extérieurs',
        sections: [{
            title: 'Mesure des murs extérieurs',
            fields: [
                { type: 'info', variant: 'warning', text: "Ne renseignez que les murs donnant vers l'EXTÉRIEUR. Une photo par mur. La surface nette = (Longueur × Hauteur) − ouvertures." },
                {
                    type: 'repeater', key: 'murs_exterieurs', label: 'Murs extérieurs', addLabel: 'Ajouter un mur extérieur',
                    photoPrefix: 'mur', photoLabel: 'Photo du mur', photoMax: 2,
                    itemFields: [
                        { type: 'text', key: 'repere', label: 'Repère / orientation', placeholder: 'Ex: Mur Nord' },
                        { type: 'number', key: 'longueur', label: 'Longueur (m)' },
                        { type: 'number', key: 'hauteur', label: 'Hauteur (m)' },
                        { type: 'number', key: 'ouvertures', label: 'Surface ouvertures (m²)' },
                    ],
                },
            ],
        }],
    },
    {
        id: 'clim', title: 'Emplacements climatisation',
        sections: [{
            title: 'Emplacements climatisation / chauffage',
            fields: [
                { type: 'info', text: "Ajoutez chaque pièce où une unité intérieure sera installée ou existe déjà. Photo obligatoire pour chaque emplacement." },
                {
                    type: 'repeater', key: 'emplacements_clim', label: 'Emplacements', addLabel: 'Ajouter une pièce',
                    photoPrefix: 'clim', photoLabel: "Photo de l'emplacement", photoMax: 2,
                    itemFields: [
                        { type: 'text', key: 'piece', label: 'Pièce', placeholder: 'Ex: Salon' },
                        { type: 'select', key: 'type_unite', label: "Type d'unité", options: ['Murale', 'Console', 'Gainable', 'Cassette', 'Autre'] },
                    ],
                },
            ],
        }],
    },
    {
        id: 'unite_ext', title: 'Unité extérieure',
        sections: [{
            title: 'Emplacement unité extérieure',
            fields: [
                {
                    type: 'cards', key: 'emplacement_ue', label: "Emplacement prévu pour l'unité extérieure", multi: false,
                    options: ['Balcon / Terrasse', 'Façade', 'Toiture', 'Jardin / Cour', 'Autre'].map((v) => ({ value: v, label: v })),
                },
                { type: 'photo', category: 'photo_unite_ext', label: "Photo de l'emplacement unité extérieure *", desc: "Endroit prévu pour l'installation", max: 3, required: true },
            ],
        }],
    },
    {
        id: 'synthese', title: 'Documents & validation',
        sections: [{
            title: 'Photos obligatoires complémentaires',
            fields: [
                { type: 'photo', category: 'photo_facade_immeuble', label: "Photo de la façade de l'immeuble *", desc: "Vue d'ensemble depuis la rue", max: 3, required: true },
                { type: 'photo', category: 'photo_tableau_elec', label: 'Photo du tableau électrique *', desc: 'Tableau électrique du logement', max: 3, required: true },
                { type: 'photo', category: 'photo_fenetres', label: 'Photos des fenêtres', max: 6 },
                { type: 'text', key: 'nom_charge_etude', label: "Nom du chargé d'étude", placeholder: "Nom du chargé d'étude", full: true },
                { type: 'textarea', key: 'commentaires', label: 'Commentaires, observations', placeholder: "Points d'attention...", full: true },
                { type: 'toggle', key: 'confirmation', label: 'Je confirme que les informations et photos correspondent bien au logement concerné.', hint: 'Obligatoire pour valider.' },
            ],
        }],
    },
];

// ====================== VARIANTE 3 : Rénovation globale — Immeuble collectif ======================
const DPE = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
const IMMEUBLE_STEPS = [
    {
        id: 'identification', title: 'Identification du projet',
        sections: [{
            fields: [
                { type: 'text', key: 'nom_residence', label: 'Nom de la résidence / immeuble', placeholder: 'Nom de la résidence / immeuble *', required: true, full: true },
                { type: 'text', key: 'adresse_complete', label: 'Adresse complète', placeholder: 'Adresse complète *', required: true, full: true },
                { type: 'text', key: 'code_postal', label: 'Code postal', placeholder: 'Code postal *', required: true },
                { type: 'text', key: 'ville', label: 'Ville', placeholder: 'Ville *', required: true },
                { type: 'select', key: 'annee_construction', label: 'Année de construction', options: ['Avant 1948', '1949 - 1974', '1975 - 1988', '1989 - 2000', 'Après 2000'] },
                { type: 'number', key: 'nb_batiments', label: 'Nombre de bâtiments', placeholder: 'Nb bâtiments' },
                { type: 'number', key: 'nb_entrees', label: "Nombre d'entrées", placeholder: 'Nb entrées' },
                { type: 'number', key: 'nb_logements', label: 'Nombre de logements', placeholder: 'Nb logements *', required: true },
            ],
        }],
    },
    {
        id: 'statut_juridique', title: 'Statut juridique & contacts',
        sections: [
            {
                fields: [{
                    type: 'cards', key: 'type_propriete', label: 'Type de propriété', multi: false,
                    options: ['Copropriété', 'Bailleur social', 'Mono-propriété', 'ASL / AFUL'].map((v) => ({ value: v, label: v })),
                }],
            },
            {
                title: 'Contact Syndic',
                fields: [
                    { type: 'text', key: 'syndic_nom', label: 'Nom du syndic', placeholder: 'Nom du syndic', full: true },
                    { type: 'text', key: 'syndic_tel', label: 'Téléphone', placeholder: 'Téléphone' },
                    { type: 'text', key: 'syndic_email', label: 'Email', placeholder: 'Email' },
                ],
            },
            {
                title: 'Président conseil syndical',
                fields: [
                    { type: 'text', key: 'csyndical_nom', label: 'Nom', placeholder: 'Nom', full: true },
                    { type: 'text', key: 'csyndical_tel', label: 'Téléphone', placeholder: 'Téléphone' },
                    { type: 'text', key: 'csyndical_email', label: 'Email', placeholder: 'Email' },
                ],
            },
        ],
    },
    {
        id: 'performance', title: 'Performance énergétique',
        sections: [{
            title: 'Performance énergétique actuelle',
            fields: [
                { type: 'cards', key: 'classe_dpe', label: 'Classe énergétique (DPE)', multi: false, options: DPE.map((v) => ({ value: v, label: v })) },
                { type: 'cards', key: 'classe_ges', label: 'Classe GES', multi: false, options: DPE.map((v) => ({ value: v, label: v })) },
                { type: 'toggle', key: 'audit_realise', label: 'Audit énergétique réalisé' },
            ],
        }],
    },
    {
        id: 'structure_bat', title: 'Structure du bâtiment',
        sections: [{
            fields: [
                { type: 'cards', key: 'type_structure', label: 'Type de structure', multi: false, options: ['Béton', 'Pierre', 'Brique', 'Parpaing', 'Mixte'].map((v) => ({ value: v, label: v })) },
                { type: 'cards', key: 'type_facade', label: 'Type de façade', multi: false, options: ['Enduit', 'Béton brut', 'Pierre apparente', 'Bardage', 'Autre'].map((v) => ({ value: v, label: v })) },
                { type: 'cards', key: 'isolation_facade', label: 'Isolation façade existante', multi: false, options: ['Aucune', 'ITI (intérieur)', 'ITE (extérieur)'].map((v) => ({ value: v, label: v })) },
            ],
        }],
    },
    {
        id: 'toiture', title: 'Toiture',
        sections: [{
            fields: [
                { type: 'cards', key: 'type_toiture', label: 'Type de toiture', multi: false, options: ['Toiture terrasse', 'Combles perdus', 'Combles aménagés', 'Pente tuiles', 'Pente ardoise'].map((v) => ({ value: v, label: v })) },
                { type: 'number', key: 'surface_toiture', label: 'Surface toiture (m²)', placeholder: 'Surface toiture (m²)' },
                { type: 'toggle', key: 'isolation_toiture_existante', label: 'Isolation existante' },
                { type: 'photo', category: 'photo_toiture', label: 'Photos de la toiture', desc: "Vues d'ensemble, accès, état général", max: 4 },
            ],
        }],
    },
    {
        id: 'planchers', title: 'Planchers bas',
        sections: [{
            fields: [
                { type: 'cards', key: 'type_plancher_bas', label: 'Type de plancher bas', multi: false, options: ['Cave / Sous-sol', 'Vide sanitaire', 'Parking souterrain', 'Terre-plein', 'Local commercial'].map((v) => ({ value: v, label: v })) },
                { type: 'number', key: 'surface_plancher_bas', label: 'Surface plancher bas (m²)', placeholder: 'Surface plancher bas (m²)' },
                { type: 'toggle', key: 'isolation_plancher_existante', label: 'Isolation existante' },
                { type: 'photo', category: 'photo_planchers', label: 'Photos des planchers / sous-sol', desc: 'Cave, vide sanitaire, parking...', max: 4 },
            ],
        }],
    },
    {
        id: 'facades', title: 'Façades',
        sections: [{
            fields: [
                { type: 'number', key: 'nb_facades', label: 'Nombre de façades', placeholder: 'Nombre de façades' },
                { type: 'number', key: 'surface_facades', label: 'Surface totale (m²)', placeholder: 'Surface totale (m²)' },
                { type: 'checks', key: 'orientations', label: 'Orientations', options: ['Nord', 'Sud', 'Est', 'Ouest'].map((v) => ({ value: v, label: v })) },
                { type: 'checks', key: 'degradations', label: 'Dégradations constatées', options: ['Fissures', 'Infiltrations', 'Décollement enduit', 'Mousse / Lichens', 'Aucune'].map((v) => ({ value: v, label: v })) },
                { type: 'photo', category: 'photo_facades', label: 'Photos des façades', desc: 'Chaque façade, détails des dégradations', max: 6 },
            ],
        }],
    },
    {
        id: 'chauffage_imm', title: 'Chauffage',
        sections: [{
            fields: [
                { type: 'cards', key: 'type_chauffage', label: 'Type de chauffage', multi: false, options: ['Collectif gaz', 'Collectif fioul', 'Individuel gaz', 'Individuel électrique', 'Réseau de chaleur', 'PAC'].map((v) => ({ value: v, label: v })) },
                { type: 'toggle', key: 'local_chaufferie', label: 'Local chaufferie présent' },
            ],
        }],
    },
    {
        id: 'ecs_imm', title: 'Eau chaude sanitaire',
        sections: [{
            title: 'Eau chaude sanitaire (ECS)',
            fields: [
                { type: 'cards', key: 'production_ecs', label: 'Production ECS', multi: false, options: ['Collective', 'Individuelle'].map((v) => ({ value: v, label: v })) },
                { type: 'cards', key: 'type_production_ecs', label: 'Type de production', multi: false, options: ['Ballon collectif', 'Via chaudière', 'Solaire thermique', 'Autre'].map((v) => ({ value: v, label: v })) },
                { type: 'number', key: 'capacite_ballon', label: 'Capacité ballon (litres)', placeholder: 'Capacité ballon (litres)' },
                { type: 'photo', category: 'photo_ballon_plaque', label: 'Photo plaque signalétique ballon', desc: 'Marque, modèle, capacité', max: 2 },
                { type: 'photo', category: 'photo_ballon_ensemble', label: "Photos ballon (vue d'ensemble)", max: 3 },
            ],
        }],
    },
    {
        id: 'ventilation', title: 'Ventilation',
        sections: [{
            fields: [
                { type: 'cards', key: 'type_ventilation', label: 'Type de ventilation', multi: false, options: ['VMC simple flux', 'VMC hygroréglable', 'VMC double flux', 'Ventilation naturelle', 'Aucune'].map((v) => ({ value: v, label: v })) },
                { type: 'cards', key: 'etat_ventilation', label: 'État de la ventilation', multi: false, options: ['Bon', 'Moyen', 'Mauvais'].map((v) => ({ value: v, label: v })) },
                { type: 'photo', category: 'photo_ventilation', label: 'Photos ventilation', desc: 'Bouches, caisson VMC, gaines...', max: 3 },
            ],
        }],
    },
    {
        id: 'communes', title: 'Parties communes',
        sections: [{
            fields: [
                { type: 'cards', key: 'type_eclairage', label: "Type d'éclairage", multi: false, options: ['LED', 'Fluorescent', 'Halogène', 'Incandescent'].map((v) => ({ value: v, label: v })) },
                { type: 'checks', key: 'equipements_communs', label: 'Équipements', options: ['Minuterie', 'Détecteur de présence', 'Ascenseur'].map((v) => ({ value: v, label: v })) },
            ],
        }],
    },
    {
        id: 'travaux', title: 'Travaux & objectifs',
        sections: [{
            title: 'Travaux envisagés et objectifs',
            fields: [
                { type: 'checks', key: 'travaux_envisages', label: 'Travaux envisagés', cards: true, options: ['Isolation façades (ITE)', 'Isolation intérieure (ITI)', 'Isolation toiture', 'Isolation plancher bas', 'Remplacement fenêtres', 'Rénovation chauffage', 'Production ECS', 'Ventilation', 'Éclairage parties communes'].map((v) => ({ value: v, label: v })) },
                { type: 'cards', key: 'objectif_gain', label: 'Objectif de gain énergétique', multi: false, options: ['>= 35%', '>= 50%', '>= 60%'].map((v) => ({ value: v, label: v })) },
                { type: 'cards', key: 'classe_cible', label: 'Classe énergétique cible après travaux', multi: false, options: ['A', 'B', 'C', 'D'].map((v) => ({ value: v, label: v })) },
            ],
        }],
    },
    {
        id: 'occupation', title: 'Occupation & profil',
        sections: [
            {
                title: 'Occupation des logements',
                fields: [
                    { type: 'number', key: 'logements_occupes', label: 'Logements occupés', placeholder: 'Logements occupés' },
                    { type: 'number', key: 'logements_vacants', label: 'Logements vacants', placeholder: 'Logements vacants' },
                    { type: 'number', key: 'proprietaires_occupants', label: 'Propriétaires occupants', placeholder: 'Propriétaires occupants' },
                    { type: 'number', key: 'locataires', label: 'Locataires', placeholder: 'Locataires' },
                ],
            },
            {
                title: 'Profil CEE / Aides',
                fields: [
                    { type: 'number', key: 'tres_modestes', label: 'Très modestes', placeholder: 'Très modestes' },
                    { type: 'number', key: 'modestes', label: 'Modestes', placeholder: 'Modestes' },
                    { type: 'number', key: 'standards', label: 'Standards', placeholder: 'Standards' },
                ],
            },
        ],
    },
    {
        id: 'synthese', title: 'Photos & validation',
        sections: [{
            title: 'Photos obligatoires et validation',
            fields: [
                { type: 'photo', category: 'photo_facade_principale', label: 'Photo façade principale du bâtiment *', desc: "Vue d'ensemble depuis la rue", max: 3, required: true },
                { type: 'photo', category: 'photo_tableau_communs', label: 'Photo tableau électrique parties communes', desc: 'Tableau électrique des communs', max: 3 },
                { type: 'text', key: 'nom_charge_etude', label: "Nom du chargé d'étude", placeholder: "Nom du chargé d'étude", full: true },
                { type: 'textarea', key: 'commentaires', label: 'Commentaires, observations', placeholder: "Points d'attention...", full: true },
                { type: 'toggle', key: 'confirmation', label: 'Je confirme que les informations et photos correspondent bien à l\'immeuble concerné.', hint: 'Obligatoire pour valider.' },
            ],
        }],
    },
];

export const STUDY_SCHEMAS = {
    cee_fiches: { label: 'Étude CEE par fiches standardisées', steps: CEE_STEPS },
    reno_appartement: { label: 'Rénovation globale — Logement / Appartement', steps: APPARTEMENT_STEPS },
    reno_immeuble: { label: 'Rénovation globale — Immeuble collectif', steps: IMMEUBLE_STEPS },
};

export function getSteps(variant) {
    const v = STUDY_SCHEMAS[variant] ? variant : 'cee_fiches';
    return [TYPE_STEP, ...STUDY_SCHEMAS[v].steps];
}

// Rétro-compat : utilisé ailleurs auparavant
export const STUDY_STEPS = getSteps('cee_fiches');
